// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

// Local imports
import { DocusignContractData, DocusignContractOutput, DocusingAgreementDataParam } from '../interface/docusign';
import { URL_DOCUSIGN } from '@tgx/shared/services';

@Injectable({ providedIn: 'root' })
export class DocusignService {
  private http = inject(HttpClient);

  private urlDocusign = inject(URL_DOCUSIGN);

  async getAgreementsList(data: DocusingAgreementDataParam): Promise<DocusignContractData[]> {
    const url = `${this.urlDocusign}get-contracts`;

    const response: DocusignContractOutput = await this.http.post<DocusignContractOutput>(url, data).toPromise();
    return response?.contracts?.length > 0 ? response.contracts : [];
  }
}
